<template>
  <section :class="$style.root">
    <div :class="$style.container">
      <!-- TODO: サブタイトルの設定 -->
      <MoleculesConsumerHeading v-if="minScreenMd" :title="title" align="left" variant="sub" />
      <div v-else :class="$style.sp_title_container">
        <p :class="$style.title">{{ title }}</p>
      </div>

      <div :class="$style.list">
        <AtomsConsumerLink v-for="(item, index) in experts" :key="index" :url="item.url ?? ''" :class="$style.item">
          <div :class="$style.image">
            <AtomsConsumerImage :src="item.pc_img_url ?? ''" :width="264" :height="198" />
          </div>
          <div :class="$style.profile_container">
            <div :class="$style.sub_text">
              <p>{{ item.sub_text1 }}</p>
              <p>{{ item.sub_text2 }}</p>
            </div>
            <div :class="$style.name">
              <p>{{ item.title }}</p>
            </div>
          </div>
        </AtomsConsumerLink>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { PagePartsFragmentFragment } from "~/types/pageParts"

type Expert = Pick<
  PagePartsFragmentFragment["list"][0],
  "url" | "pc_img_url" | "sub_text1" | "sub_text2" | "title" | "subtitle"
>

type Props = {
  experts: Expert[]
  title?: string
  linkUrl?: string
}

withDefaults(defineProps<Props>(), {
  experts: () => [],
  linkUrl: "",
  title: "",
})

const { width: windowWidth } = useWindowSize()
const minScreenMd = computed(() => windowWidth.value >= 768)
</script>

<style scoped module lang="scss">
.root {
  width: 100%;
  background-color: $primary-10;
  .container {
    max-width: $max-width-xl;
    padding: 3rem 0 0 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin: 0 auto;

    @include md {
      gap: 2.5rem;
      padding: 6.25rem 5rem 0;
    }

    .sp_title_container {
      color: $primary;
      .title {
        font-size: $font-size-24;
        font-weight: 600;
      }
    }

    .list {
      display: grid;
      column-gap: 1.25rem;
      grid-auto-flow: column;
      overflow-x: scroll;
      padding-bottom: 3rem;

      @include md {
        grid-template-columns: repeat(auto-fit, calc(25% - 18px));
        column-gap: 1.875rem;
        padding-bottom: 6.25rem;
      }

      .item {
        display: flex;
        flex-direction: column;
        gap: 1rem;

        @include md {
          gap: 1.25rem;
        }
        .image {
          aspect-ratio: 264 / 198;

          @include md {
            aspect-ratio: 338 / 253;
          }

          img {
            @include md {
              object-fit: cover;
              width: 100%;
              height: 100%;
              vertical-align: top;
            }
          }
        }

        .profile_container {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;

          .sub_text {
            font-size: $font-size-11;
            font-weight: 400;

            @include md {
              font-size: $font-size-13;
            }
          }

          .name {
            font-size: $font-size-14;
            font-weight: 400;

            @include md {
              font-size: $font-size-15;
            }
          }
        }
      }
    }
  }
}
</style>
